import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Checkbox = ({ selected, onClick }) => {
	return <i className={'checkbox' + (selected ? ' checked' : '')} onClick={onClick} />;
};

Checkbox.propTypes = {
	selected: PropTypes.bool,
	onClick: PropTypes.func
};

export default Checkbox;
